import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from '@/components/Layout'
import { SearchPage } from '@/pages/SearchPage'
import { SavedAdsPage } from '@/pages/SavedAdsPage'
import CapturedAdsPage from '@/pages/CapturedAdsPage'
import MinerPage from '@/pages/MinerPage'
import { StatsPage } from '@/pages/StatsPage'
import { TrackedPagesPage } from '@/pages/TrackedPagesPage'
import { SearchHistoryPage } from '@/pages/SearchHistoryPage'
import TrackedAdvertisersPage from '@/pages/TrackedAdvertisersPage'
import { SettingsPage } from '@/pages/SettingsPage'
import { UserPlansPage } from '@/pages/UserPlansPage'
import { AdminUsersPage } from '@/pages/AdminUsersPage'
import { AuthPage } from '@/pages/AuthPage'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { UpdateToast } from '@/components/UpdateToast'
import { useAutoUpdate } from '@/hooks/useAutoUpdate'
import { useAuth } from '@/contexts/AuthContext'

function App() {
  const { updateAvailable, refreshApp } = useAutoUpdate()
  const { user } = useAuth()
  const esViewer = user?.role === 'viewer'

  return (
    <>
    <Routes>
      {/* Public route for authentication */}
      <Route
        path="/auth"
        element={
          <ProtectedRoute requireAuth={false}>
            <AuthPage />
          </ProtectedRoute>
        }
      />

      {/* Protected routes */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <div className="min-h-screen bg-stone-950 text-stone-100">
              <div className="grid-background" aria-hidden />

              <Layout>
                <Routes>
                  {/* Las cuentas viewer solo ven capturas: cualquier ruta cae aquí. El
                      backend además les da 403 en el resto de la API. */}
                  {esViewer ? (
                    <>
                      <Route path="/captured-ads" element={<CapturedAdsPage />} />
                      <Route path="*" element={<Navigate to="/captured-ads" replace />} />
                    </>
                  ) : (
                    <>
                      <Route path="/" element={<SearchPage />} />
                      <Route path="/search" element={<SearchPage />} />
                      <Route path="/saved-ads" element={<SavedAdsPage />} />
                      <Route path="/captured-ads" element={<CapturedAdsPage />} />
                      <Route path="/miner" element={<MinerPage />} />
                      <Route path="/search-history" element={<SearchHistoryPage />} />
                      <Route path="/tracked-advertisers" element={<TrackedAdvertisersPage />} />
                      <Route path="/settings" element={<SettingsPage />} />
                      <Route path="/user-plans" element={<UserPlansPage />} />
                      <Route path="/admin/users" element={<AdminUsersPage />} />
                      <Route path="/stats" element={<StatsPage />} />
                      <Route path="/pages" element={<TrackedPagesPage />} />
                    </>
                  )}
                </Routes>
              </Layout>
            </div>
          </ProtectedRoute>
        }
      />
    </Routes>

    {/* Aviso de nueva versión disponible */}
    <UpdateToast show={updateAvailable} onRefresh={refreshApp} />
    </>
  )
}

export default App
